import { type NetworkPayload } from "../../../composites";

const quickActionsAPI = {
  fetch: () => ({
    url: "user_quick_actions/",
    options: {
      method: "GET" as const,
    },
  }),
  fetchCatalog: (): NetworkPayload => ({
    url: "quick_action_catalog/",
    options: {
      method: "GET",
    },
  }),
  post: (actionKeys: string[]): NetworkPayload => ({
    url: "user_quick_actions/",
    options: {
      method: "POST",
      isJsonResponse: false,
      payload: { action_keys: actionKeys },
    },
  }),
};

export default quickActionsAPI;
